Ext.define('SA.QuickReportExportConfig', {
    extend: 'SA.ExportConfig',

    resource: 'quickReportTemplate',
    excelOnly: true,

    async prepare() {
        var quickReportTemplate = this.model.getQuickReportTemplate(),
            locationItems = this.model.getLocations().map(location => SA.data.LocationsCache.toLocationItem(location));

        this.params = {quickReportTemplate, locationItems};
        this.limitCheck = await SA.LimitCheck.getForLocations(this.params);
    }
});